import { LocationsOfCitiesProps } from "./types";

export const locationsOfCities: LocationsOfCitiesProps = [
    {
      name: "Chernivtsi",
      lat: 48.2921,
      lng: 25.9318,
    },
    {
      name: "Dnipro",
      lat: 48.4517,
      lng: 35.0156,
    },
    {
      name: "Kyiv",
      lat: 50.4416,
      lng: 30.5248,
    },
    {
      name: "Chernihiv",
      lat: 51.4902,
      lng: 31.2743,
    },
    {
      name: "Kharkiv",
      lat: 49.9787,
      lng: 36.2613,
    },
    {
      name: "Donetsk",
      lat: 48.0113,
      lng: 37.8049,
    },
    {
      name: "Luhansk",
      lat: 48.564,
      lng: 39.2951,
    },
    {
      name: "Odesa",
      lat: 46.4721,
      lng: 30.7234,
    },
    {
      name: "Mykolayiv",
      lat: 46.9629,
      lng: 31.9991,
    },
    {
      name: "Kherson",
      lat: 46.6426,
      lng: 32.61,
    },
    {
      name: "Lviv",
      lat: 49.8365,
      lng: 24.0349,
    },
    {
      name: "Ivano-Franskivsk",
      lat: 48.9177,
      lng: 24.7102,
    },
    {
      name: "Uzhhorod",
      lat: 48.6154,
      lng: 22.2808,
    },
    {
      name: "Cherkasy",
      lat: 49.4321,
      lng: 32.0513,
    },
    {
      name: "Poltava",
      lat: 49.5968,
      lng: 34.5208,
    },
    {
      name: "Kropyvnytskyi",
      lat: 48.5113,
      lng: 32.2573,
    },
    {
      name: "Zaporizhzhia",
      lat: 47.85,
      lng: 35.1518,
    },
    {
      name: "Lutsk",
      lat: 50.7513,
      lng: 25.3348,
    },
    {
      name: "Ternopil",
      lat: 49.5495,
      lng: 25.5973,
    },
    {
      name: "Sumy",
      lat: 50.9116,
      lng: 34.7956,
    },
    {
      name: "Zhytomyr",
      lat: 50.2617,
      lng: 28.6747,
    },
    {
      name: "Rivne",
      lat: 50.6125,
      lng: 26.2149,
    },
    {
      name: "Vinnytsia",
      lat: 49.2363,
      lng: 28.4701,
    },
    {
      name: "Simferopol",
      lat: 44.9554,
      lng: 34.1169,
    },
    {
      name: "Khmelnytskyi",
      lat: 49.4122,
      lng: 27.0018,
    },
  ];